import React from "react";
import { Navigate } from "react-router-dom";

function Protected ({isLoggedIn, children}) {
    console.log('hooosh', isLoggedIn)
    if(!isLoggedIn) {
        return <Navigate to={'/agent/login'}/>
    }
    return children
}

export default Protected